import { render, staticRenderFns } from "./message-field.vue?vue&type=template&id=59f3b502&scoped=true"
import script from "./message-field.vue?vue&type=script&lang=ts"
export * from "./message-field.vue?vue&type=script&lang=ts"
import style0 from "./message-field.vue?vue&type=style&index=0&id=59f3b502&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f3b502",
  null
  
)

export default component.exports